const styles = theme => ({
    root: {
        padding: '0 10rem 210px 10rem',
        marginTop: '-1px',
        maxWidth: '1700px',
        position: 'relative',
        margin: 'auto',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1350)]: {
            padding: '0 80px 210px 80px',
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 890)]: {
            padding: '0 1rem'
        }
    },
    h1: {
        margin: '0',
        fontFamily: 'Montserrat',
        fontWeight: '700',
        fontSize: '60px',
        lineHeight: '75px',
        letterSpacing: '0.01em',
        color: 'black',
        maxWidth: '16ch',
        marginBottom: '40px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 890)]: {
            maxWidth: '100%',
            marginBottom: '20px'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 700)]: {
            fontSize: '2rem',
            lineHeight: '38.5px'
        }
    },
    p: {
        margin: 0,
        color: 'black',
        fontFamily: 'Aktiv Grotesk',
        display: 'table',
        fontSize: '1rem',
        lineHeight: '22.4px',
        letterSpacing: '0.01em',
        maxWidth: '73ch',
        marginBottom: '25px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 890)]: {
            maxWidth: '100%',
            marginBottom: '30px'
        }
    },
    shrinkIframe: {
        width: '100%',
        padding: '0 120px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1350)]: {
            padding: '0',
        }
    },
    iframeWrap: {
        position: 'relative',
        zIndex: 3,
        paddingBottom: '56.25%',
        height: '0',
        boxShadow: '5px 5px 30px rgba(0, 0, 0, 0.2)',
        width: '100%',
        overflow: 'hidden'
    },
    iframe: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
    }
})

export default styles